import { RemoteScheduledPushNotificationGetById } from 'data/usecases';
import { ScheduledPushNotificationGetByIdUseCaseInterface } from 'domain/usecases';
import { makeApiUrlScheduledPushNotificationGetById } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeScheduledPushNotificationGetById =
  (): ScheduledPushNotificationGetByIdUseCaseInterface =>
    new RemoteScheduledPushNotificationGetById(
      makeApiUrlScheduledPushNotificationGetById(),
      makeAxiosHttpClient(),
    );
